import { SimpleQuestionAnswer } from 'types/enums';
import { HistoryAnswers, HistoryQuestion } from 'types/refData';

import { AppDispatch } from '../../../store';
import { qalTrackEventAction } from '../../../thunks/analytics';

export const getExtraCustomerDetails = (
  claimCount: string | null,
  applied: boolean | null,
  dispatch: AppDispatch
) => {
  // Business Claim Counts
  if (claimCount !== null) {
    dispatch(
      qalTrackEventAction({
        event: 'submit',
        eventAction: 'select business claim counts',
        eventLabel: claimCount.toLowerCase(),
      })
    );
  }
  // Business History applied.
  if (applied !== null) {
    dispatch(
      qalTrackEventAction({
        event: 'submit',
        eventAction: 'select business history applied',
        eventLabel: applied.toString(),
      })
    );
  }
};

export const trackCustomerHistory = (
  historyAnswers: HistoryAnswers[] | null,
  historyQuestions: HistoryQuestion[] | null,
  dispatch: AppDispatch
) => {
  if (!historyAnswers || !historyQuestions) return;

  historyAnswers.forEach((value, index) => {
    dispatch(
      qalTrackEventAction({
        event: 'submit',
        eventAction: historyQuestions[index + 2].questionText,
        eventLabel: value.answer! ? SimpleQuestionAnswer.Yes : SimpleQuestionAnswer.No,
      })
    );
  });
};
